var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.33337C5 8.78109 5.44772 8.33337 6 8.33337H26C26.5523 8.33337 27 8.78109 27 9.33337C27 9.88566 26.5523 10.3334 26 10.3334H6C5.44772 10.3334 5 9.88566 5 9.33337Z",
    fill: "#121212"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 16C5 15.4478 5.44772 15 6 15H26C26.5523 15 27 15.4478 27 16C27 16.5523 26.5523 17 26 17H6C5.44772 17 5 16.5523 5 16Z",
    fill: "#121212"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 21.6667C5.44772 21.6667 5 22.1144 5 22.6667C5 23.219 5.44772 23.6667 6 23.6667H26C26.5523 23.6667 27 23.219 27 22.6667C27 22.1144 26.5523 21.6667 26 21.6667H6Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarButton);
export default __webpack_public_path__ + "static/media/sidebar_button.b1413bb5f2fb27e9f455019eb8c59ab5.svg";
export { ForwardRef as ReactComponent };